export class Maps {
  public static valueByKey<K = any, V = any>(
    map: Map<K, V> | undefined,
    key: K,
    defaultValue: V
  ): V {
    if (!map) {
      return defaultValue;
    }
    const value = map.get(key);
    return value === undefined ? defaultValue : value;
  }
}
